<template>
  <!-- 根据tableData的值去显示隐藏列表 -->
  <div style="height:100%">
    <div class="Main" style="padding-bottom:0;" v-if="empty">
      <div class="topMain">
        <div slot="header" class="clearfix">
          <span>网关协议库</span>
          <el-button style="float: right;" type="primary" @click="dialogFormVisible = true"
            v-if="user_name != 'suadmin'">导入</el-button>
          <el-button style="float: right;margin-right:20px" v-if="multipleSelection.length == 0" type="primary"
            @click="addBtn">创建</el-button>
        </div>
      </div>
      <div class="coreMain">
        <div>
          <el-input class="input-with-select" placeholder="输入网关协议名称或编号搜索" @keyup.enter.native="searchBtn"
            v-model="search">
          </el-input>
          <el-select v-model="type" placeholder="请选择协议类型" @change="getMyprotocol">
            <el-option v-for="item in protocolTypes" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-button @click="searchBtn" icon="el-icon-search" type="primary"
            :class="search.length == 0 ? 'ccc' : 'blue'"></el-button>
          <el-button class="clearSearch" type="text" @click="reset">清除搜索条件</el-button>
        </div>
        <el-table v-loading="loading" ref="multipleTable" :data="tableData" style="width: 100%">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="名称" min-width="150px">
            <template slot-scope="scope">
              <el-button class="tableButton" @click="detailBtn(scope.row.id)">
                {{ scope.row.name }}</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="code" label="编号"></el-table-column>
          <el-table-column v-if="commuType ==1 || commuType == 2" prop="commuPort" label="端口"></el-table-column>
          <el-table-column prop="analysisTemplate" label="协议解析模板">
            <template slot-scope="scope">
              <div v-if="scope.row.analysisTemplateType == 1">
                <span v-if="scope.row.analysisTemplate==1">DLT45-2007规约</span>
                <span v-else-if="scope.row.analysisTemplate==2">DLT45-1997规约</span>
                <span v-else-if="scope.row.analysisTemplate==3">ModbusTCP</span>
                <span v-else-if="scope.row.analysisTemplate==4">ModbusRTU</span>
                <span v-else>私有协议</span>
              </div>
              <div v-if="scope.row.analysisTemplateType == 2">
                <span>私有协议</span>
              </div>

            </template>
          </el-table-column>
          <el-table-column prop="createDate" label="创建日期" :formatter="formatDate"></el-table-column>
          <el-table-column prop="creator" label="创建人"></el-table-column>
          <el-table-column label="">
            <template slot-scope="scope">
              <el-dropdown class="briefDetails" style="top:22px;right:32px" @command="command">
                <span class="el-dropdown-link">
                  <i class="el-icon-more"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-if="(scope.row.type != 1 && user_name != 'suadmin') || (scope.row.type == 1 && user_name == 'suadmin')"
                    :command="{ type: 'edit', id: scope.row.id }">编辑</el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.type != 1 && user_name == 'suadmin'"
                    :command="{ type: 'upgrade', id: scope.row.id }">升级</el-dropdown-item>
                  <el-dropdown-item
                    v-if="(scope.row.type != 1 && user_name != 'suadmin') || (scope.row.type == 1 && user_name == 'suadmin')"
                    :command="{ type: 'del', id: scope.row.id }">删除</el-dropdown-item>
                  <el-dropdown-item :command="{ type: 'export', id: scope.row.id }">导出</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
          :page-sizes="[10,50,100,200,500,1000]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>

    <!-- 没有网关显示的内容 -->
    <div class="emptyMain" v-if="!empty">
      <el-card class="box-card">
        <img src="../../assets/images/wangguan.png" alt="" />
        <p style="color:#303133">您还没有创建任何网关协议</p>
        <br />
        <el-button>了解详情</el-button>
        <el-button type="primary" @click="addBtn">创建网关协议</el-button>
      </el-card>
    </div>
    <!-- 导入网关协议模态框 -->
    <el-dialog title="导入网关协议" :visible.sync="dialogFormVisible">
      <el-upload :action='upload' accept=".json" :data="tokenData" show-file-list class="upload-demo" :limit='1'
        :file-list="attachmentIdFileList" :on-success='uploadSuccess' :on-remove='uploadRemove' :on-error="uploadError"
        drag>
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div style="margin-top: 10px">只能上传json文件（以json为后缀），其他类型文件将无法成功创建协议。</div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false;attachmentIdFileList=[]">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 删除结果弹出框 -->
    <el-dialog :title="'删除结果'" :visible.sync="delErrorMsgMaskVisible" width="30%" :close-on-click-modal="false">
      <el-table ref="multipleTable" :data="delErrorMsgTableData" :border="true">
        <el-table-column prop="code" label="编号" align="center"></el-table-column>
        <el-table-column prop="errorMsg" label="错误信息">
          <template slot-scope="scope">
            <span style="color: #ff0000;">{{ scope.row.errorMsg }}</span>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="delErrorMsgResultOff">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import API from "../../api/api";
  import dayjs from 'dayjs'
  export default {
    data() {
      return {
        delErrorMsgMaskVisible: false,
        delErrorMsgTableData: [],
        user_name: this.$cookies.get("user_name"),
        commuType: sessionStorage.getItem('commuType'),
        loading: false, //加载条
        empty: false, //控制数据为空展示空页面
        total: 0,
        currentPage: 1,
        pageSize: 10,
        search: "", //搜索
        model: [],
        modelList: [],
        tableData: [], //我的协议
        multipleSelection: [], //我的协议-选中的值
        type: 0,
        protocolTypes: [{
            value: 0,
            label: '全部协议'
          },
          {
            value: 1,
            label: '平台协议'
          },
          {
            value: 2,
            label: '自有协议'
          }
        ],
        dialogFormVisible: false,
        attachmentIdFileList: [],
        upload: API.importMduProtocolUrl(), //上传地址
      };
    },
    computed: {
      tokenData: function () {
        return {
          access_token: this.$cookies.get('access_token'),
          commuType: sessionStorage.getItem("commuType")
        }
      }
    },
    created() {},
    methods: {
      formatDate(row, column, cellValue, index) {
        if (row.createDate) {
          return dayjs(new Date(row.createDate)).format("YYYY-MM-DD HH:mm:ss")
        } else {
          return '--'
        }
      },

      //初始化页面
      init() {
        //获取私有协议数据
        let para = {
          commuType: sessionStorage.getItem('commuType'),
          pageSize: this.pageSize,
          currentPage: this.currentPage,
          type: this.type,
        };
        API.platformMduProtocolSelfPage(para).then(res => {
          if (res.code == 1) {
            this.tableData = res.data.resultPage;
            this.total = res.data.total;
          }
        });
        //品牌型号级联数据
        API.platformMduProtocolBrandAndModel().then(res => {
          if (res.code == 1) {
            this.modelList = res.data.brandAndModel;
          }
        });
        if (
          this.tableData.length == 0
        ) {
          this.empty = true; //没有数据显示空页面
        } else {
          this.empty = false; //没有数据显示空页面
        }
      },
      //获取私有协议数据
      getMyprotocol() {
        let para = {
          commuType: sessionStorage.getItem('commuType'),
          type: this.type,
          brand: this.model[0],
          model: this.model[1],
          code: this.search, //搜索栏
          pageSize: this.pageSize,
          currentPage: this.currentPage
        };
        API.platformMduProtocolSelfPage(para).then(res => {
          if (res.code == 1) {
            this.tableData = res.data.resultPage;
            this.total = res.data.total;
          }
        });
      },
      //搜索功能
      searchBtn() {
        this.currentPage = 1;
        this.getMyprotocol();
      },
      //
      changeModel() {
        this.currentPage = 1;
        this.getMyprotocol();
      },
      //清除搜索条件
      reset() {
        this.search = "";
        this.model = [];
        this.type = 2;
        this.currentPage = 1;
        this.getMyprotocol();
      },
      //操作
      operationBtn(val) {
        if (val.type == "del") {
          let str = val.para.join(",");
          this.delBtn(str);
        }
      },
      //选中我的协议
      selectionBtn(val) {
        if (val.flag == false) {
          var index = this.multipleSelection.indexOf(val.id); //先获取取消选中按钮的下标
          if (index > -1) {
            //大于-1证明存在，然后splice删除
            this.multipleSelection.splice(index, 1);
          }
        }
        if (val.flag == true) {
          //选中的赋值给multipleSelection
          this.multipleSelection.push(val.id);
        }
      },
      //关闭删除结果
      delErrorMsgResultOff() {
        this.delErrorMsgMaskVisible = false;
        this.getpageList();
      },
      //删除功能---批量删，单独删都能用
      delBtn(delID) {
        let para = {
          ids: delID
        };
        this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
          .then(() => {
            if (this.user_name == 'suadmin') {
              API.delPlatformMduProtocolCommon(para).then(res => {
                if (res.code == 1) {
                  this.$message.success("删除成功");
                  this.getMyprotocol();
                } else {
                  var falseList = res.data;
                  this.delErrorMsgTableData = [];
                  this.tableData.forEach(item => {
                    falseList.forEach(errMsg => {
                      if (errMsg.indexOf(item.id) != -1) {
                        this.delErrorMsgTableData.push({
                          code: item.code,
                          errorMsg: errMsg.substring(errMsg.indexOf('删除失败'))
                        })
                        return;
                      }
                    })
                  });
                  this.delErrorMsgMaskVisible = true;
                }
              });
              return;
            }
            API.delPlatformMduProtocolPrivate(para).then(res => {
              if (res.code == 1) {
                this.$message.success("删除成功");
                this.getMyprotocol();
              } else {
                var falseList = res.data;
                this.delErrorMsgTableData = [];
                this.tableData.forEach(item => {
                  falseList.forEach(errMsg => {
                    if (errMsg.indexOf(item.id) != -1) {
                      this.delErrorMsgTableData.push({
                        code: item.code,
                        errorMsg: errMsg.substring(errMsg.indexOf('删除失败'))
                      })
                      return;
                    }
                  })
                });
                this.delErrorMsgMaskVisible = true;
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除"
            });
          });
      },
      //点击操作
      command(para) {
        let id = para.id;
        if (para.type == "detail") {
          //详情
          this.detailBtn(id);
        } else if (para.type == "edit") {
          //编辑
          this.$router.push({
            path: "/device/protocolAdd",
            query: {
              id: id,
              flag: "edit"
            }
          });
        } else if (para.type == "del") {
          //删除
          this.delBtn(id);
        } else if (para.type == "export") {
          //导出
          let token = this.$cookies.get('access_token');
          let url = id + "&access_token=" + (token ? token : '');
          console.log(id);
          window.open(API.exportMduProtocolUrl(url))
        } else if (para.type == "upgrade") {
          API.upgradePlatformMduProtocol(id)
            .then(res => {
              if (res.code == 1) {
                this.$message({
                  message: "升级成平台网关协议成功！",
                  type: "success"
                });
              } else {
                this.$message({
                  message: res.msg,
                  type: "error"
                });
              }
            });
        }
      },
      //跳转详情页
      detailBtn(id) {
        this.$router.push({
          path: "/device/moduleProtocolDetails",
          query: {
            id: id
          }
        });
      },
      //跳转创建网关页
      addBtn() {
        this.$router.push({
          path: "/device/protocolAdd"
        });
      },
      //导入协议组件方法
      uploadError() {
        this.$message.error('上传出错')
      },
      uploadRemove() {},
      uploadSuccess(e) {
        if (e.code === 1) {
          this.$message.success('上传成功')
          this.getMyprotocol();
        } else {
          this.$message.error(e.msg)
          this.attachmentIdFileList = []
        }

      },
      //分页
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getMyprotocol();
      },
      handleSizeChange(val) {
        this.pageSize = val;
        this.getMyprotocol();
      },
    },
    mounted() {
      this.init();
    }
  };

</script>



// WEBPACK FOOTER //
// src/views/platform/protocolLibraryManagement.vue